<template>
    <v-app >
        <v-main id="v_main">
            <template v-if="$route.path == '/login'">
                <router-view class="login" />
            </template>
            <template v-else>
                {{$store.domain}}
                <v-bottom-navigation v-if="getUser" class="h-panel" v-model="bar">
                    <v-btn value="0" class="d-none">
                        <span>css</span>
                        <i class="fas fa-file-code"></i>
                    </v-btn>
                    <v-btn value="css">
                        <span>css</span>
                        <i class="fas fa-file-code"></i>
                    </v-btn>
                    <v-btn value="setting" @click="$refs.mod.dialogDescription = true">
                        <span>Настройки</span>
                        <i class="fas fa-cog"></i>
                    </v-btn>
                    <v-btn value="exit">
                        <span>Выход</span>
                        <i class="fas fa-sign-out-alt"></i>
                    </v-btn>
                </v-bottom-navigation>
                <div v-if="getPageLoad !== true && getTemplateLoad !== true" class="loader">
                    <div class="cssload-thecube">
                        <div class="cssload-cube cssload-c1"></div>
                        <div class="cssload-cube cssload-c2"></div>
                        <div class="cssload-cube cssload-c4"></div>
                        <div class="cssload-cube cssload-c3"></div>
                    </div>
                </div>
                <v-card :class="ssr ? 'd-none' : ''" flat tile id="v_card_2">
                    <v-card-text style="overflow: auto; position: fixed; height: 100%; padding: 0" id="v_card_1">
                        <Header id="header_all" />
                        <router-view id="all_content" :key="$route.params.id" />
                        <Footer />
                        <Modal ref="mod" />
                    </v-card-text>
                </v-card>
            </template>
        </v-main>
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Footer from "./footer";
import Header from "./header";
import Modal from "../components/modal";
import Drower from "../components/drower";

export default {
    data: () => ({
        items: ["Москва", "Санкт-Петербург", "Ростов-на-Дону"],
        menu: ["Лечение алкоголизма", "Лечение наркомании"],
        isActive: true,
        ssr: false,
        bar: 0,
    }),
    watch: {
        getEditor(val) {
            if(val) {
                this.$refs.mod.dialogEdit = true;
                this.$refs.mod.editText = val.code;
                this.$refs.mod.editName = val.block;
            }
        },
        bar(val) {
            switch (val) {
                case 'exit':
                    this.exit()
                    break;
            }
        }
    },
    computed: {
        ...mapGetters(["getPageLoad", "getTemplateLoad", "getEditor", "getUser"])
    },
    components: {
        Footer,
        Header,
        Modal,
        // Drower,
    },
};
</script>

<style scoped>
    .h-panel {
        display: flex;
        justify-content: flex-end;
    }
    .loader {
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        z-index: 10000000;
        background: #fff;
        align-items: center;
        justify-content: center;
    }

    .cssload-thecube {
        width: 73px;
        height: 73px;
        margin: 0 auto;
        margin-top: 49px;
        position: relative;
        transform: rotateZ(45deg);
            -o-transform: rotateZ(45deg);
            -ms-transform: rotateZ(45deg);
            -webkit-transform: rotateZ(45deg);
            -moz-transform: rotateZ(45deg);
    }
    .cssload-thecube .cssload-cube {
        position: relative;
        transform: rotateZ(45deg);
            -o-transform: rotateZ(45deg);
            -ms-transform: rotateZ(45deg);
            -webkit-transform: rotateZ(45deg);
            -moz-transform: rotateZ(45deg);
    }
    .cssload-thecube .cssload-cube {
        float: left;
        width: 50%;
        height: 50%;
        position: relative;
        transform: scale(1.1);
            -o-transform: scale(1.1);
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -moz-transform: scale(1.1);
    }
    .cssload-thecube .cssload-cube:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(43,160,199);
        animation: cssload-fold-thecube 2.76s infinite linear both;
            -o-animation: cssload-fold-thecube 2.76s infinite linear both;
            -ms-animation: cssload-fold-thecube 2.76s infinite linear both;
            -webkit-animation: cssload-fold-thecube 2.76s infinite linear both;
            -moz-animation: cssload-fold-thecube 2.76s infinite linear both;
        transform-origin: 100% 100%;
            -o-transform-origin: 100% 100%;
            -ms-transform-origin: 100% 100%;
            -webkit-transform-origin: 100% 100%;
            -moz-transform-origin: 100% 100%;
    }
    .cssload-thecube .cssload-c2 {
        transform: scale(1.1) rotateZ(90deg);
            -o-transform: scale(1.1) rotateZ(90deg);
            -ms-transform: scale(1.1) rotateZ(90deg);
            -webkit-transform: scale(1.1) rotateZ(90deg);
            -moz-transform: scale(1.1) rotateZ(90deg);
    }
    .cssload-thecube .cssload-c3 {
        transform: scale(1.1) rotateZ(180deg);
            -o-transform: scale(1.1) rotateZ(180deg);
            -ms-transform: scale(1.1) rotateZ(180deg);
            -webkit-transform: scale(1.1) rotateZ(180deg);
            -moz-transform: scale(1.1) rotateZ(180deg);
    }
    .cssload-thecube .cssload-c4 {
        transform: scale(1.1) rotateZ(270deg);
            -o-transform: scale(1.1) rotateZ(270deg);
            -ms-transform: scale(1.1) rotateZ(270deg);
            -webkit-transform: scale(1.1) rotateZ(270deg);
            -moz-transform: scale(1.1) rotateZ(270deg);
    }
    .cssload-thecube .cssload-c2:before {
        animation-delay: 0.35s;
            -o-animation-delay: 0.35s;
            -ms-animation-delay: 0.35s;
            -webkit-animation-delay: 0.35s;
            -moz-animation-delay: 0.35s;
    }
    .cssload-thecube .cssload-c3:before {
        animation-delay: 0.69s;
            -o-animation-delay: 0.69s;
            -ms-animation-delay: 0.69s;
            -webkit-animation-delay: 0.69s;
            -moz-animation-delay: 0.69s;
    }
    .cssload-thecube .cssload-c4:before {
        animation-delay: 1.04s;
            -o-animation-delay: 1.04s;
            -ms-animation-delay: 1.04s;
            -webkit-animation-delay: 1.04s;
            -moz-animation-delay: 1.04s;
    }



    @keyframes cssload-fold-thecube {
        0%, 10% {
            transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
                    75% {
            transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
                    100% {
            transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }

    @-o-keyframes cssload-fold-thecube {
        0%, 10% {
            -o-transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
                    75% {
            -o-transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
                    100% {
            -o-transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }

    @-ms-keyframes cssload-fold-thecube {
        0%, 10% {
            -ms-transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
                    75% {
            -ms-transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
                    100% {
            -ms-transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }

    @-webkit-keyframes cssload-fold-thecube {
        0%, 10% {
            -webkit-transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
                    75% {
            -webkit-transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
                    100% {
            -webkit-transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }

    @-moz-keyframes cssload-fold-thecube {
        0%, 10% {
            -moz-transform: perspective(136px) rotateX(-180deg);
            opacity: 0;
        }
        25%,
                    75% {
            -moz-transform: perspective(136px) rotateX(0deg);
            opacity: 1;
        }
        90%,
                    100% {
            -moz-transform: perspective(136px) rotateY(180deg);
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?47be8276